






































import Vue from "vue";
import { ref, computed, onMounted, Ref } from "@vue/composition-api";
import AppCheckbox from "../AppCheckbox.vue";
import { SharedState } from "@/common/state";
import PremiumBtn from "@/components/premium/PremiumBtn.vue";
export default Vue.extend({
  props: ["items"],
  components: {
    PremiumBtn,
    AppCheckbox
  },
  setup(props, { emit }) {
    const name = ref("");
    const isNameValid = computed(() => name.value.trim().length > 0);
    const keys: Ref<Array<{
      key: string;
      name: string;
      checked: boolean;
    }>> = ref([]);
    const isKeysValid = computed(() => keys.value.some(l => l.checked));

    const disableSave = computed(
      () => !isKeysValid.value || !isNameValid.value
    );

    onMounted(() => {
      keys.value = (props.items as Array<{ key: string; name: string }>).map(
        p => {
          const isPremium =
            p.key === "topics" &&
            !SharedState.loggedUser.value.paymentEdition.topics;
          return {
            ...p,
            name: p.name ? p.name : p.key,
            disable: isPremium,
            isPremium,
            checked: !isPremium
          };
        }
      );
    });
    const exportFile = () => {
      if (disableSave.value) return;
      emit("action", {
        fileName: name.value,
        keys: keys.value
          .filter(k => k.checked)
          .map(item => {
            return {
              ...item,
              name: item.name ? item.name : item.key
            };
          })
      });
    };
    return {
      name,
      keys,
      disableSave,
      exportFile
    };
  }
});
